import req from '../../api/request'
import { ENDPOINTS } from '../../api/endpoints'
import type { GameStat, StatsRole } from '../../features/profile/stats/types'

export interface GetPlayerRecentGameStatsArgs {
  playerId: string
  sportId: string
  role: StatsRole
}

export interface GetPlayerScheduleGameStatsArgs {
  playerId: string
  scheduleId: string
  role: StatsRole
}

export const getPlayerRecentGameStats = async ({
  playerId,
  sportId,
  role,
}: GetPlayerRecentGameStatsArgs): Promise<GameStat[]> => {
  const response = await req(
    ENDPOINTS.PLAYERS.GET_PLAYER_RECENT_GAME_STATS(playerId),
    { query: { sport_id: sportId, goalie: role === 'goalie' ? 1 : 0 } }
  )
  return Array.isArray(response?.data) ? response.data : []
}

export const getPlayerScheduleGameStats = async ({
  playerId,
  scheduleId,
  role,
}: GetPlayerScheduleGameStatsArgs): Promise<GameStat[]> => {
  const response = await req(
    ENDPOINTS.PLAYERS.GET_PLAYER_SCHEDULE_GAME_STATS(playerId, scheduleId),
    { query: { goalie: role === 'goalie' ? 1 : 0 } }
  )
  return Array.isArray(response?.data) ? response.data : []
}
